/*
Copyright (c) 2021
*/

import actions from '../../actions';

const initialState = {
  loading: false,
  received: false,
  data: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.AddVideoTagAction.REQUEST_ADDVIDEOTAG:
      return {
        ...state,
        loading: true,
        received: false,
        data: null
      };
    case actions.AddVideoTagAction.ADDVIDEOTAG_RECEIVED:
      return {
        ...state,
        loading: false,
        received: true,
        data: action.data
      };

    default:
      return state;
  }
};

export default reducer;
